import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TravelSchedulerComponent } from '../travel-scheduler.component';

const routes: Routes = [
  {
    path: '',
    component: TravelSchedulerComponent,
    data: { title: 'Travel Scheduler' },
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TravelSchedulerRoutingModule {}

@NgModule({
  declarations: [],
  imports: [CommonModule, TravelSchedulerRoutingModule, TravelSchedulerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TravelSchedulerModule {}
